import { Fragment } from 'react';

import { Switch as HeadlessSwitch } from '@headlessui/react';

import { cn } from 'lib/helpers/utility';

import { getLabelClasses, getSwitchClasses } from './lib/getClasses';

/**
 * @param {import('./lib/propTypes').SwitchProps} props
 */

const Switch = ({
  onChange = () => {},
  checked = false,
  color = 'primary', // our themes
  onColor = '', //custom colors
  offColor = '', //custom colors
  onHandleColor = '', //custom colors
  offHandleColor = '', //custom colors
  size = 'small',
  label = '',
  labelClassName = '',
  dataQa = 'switch',
  disabled = false,
  parentContainerClassName = '',
  ...rest
}) => {
  const {
    button: buttonClasses,
    knob: knobClasses,
    dimensions
  } = getSwitchClasses({
    checked,
    disabled,
    color,
    size,
    hasCustomColor: !!onColor
  });

  const { dotSize, translateChecked } = dimensions;

  return (
    <div className={parentContainerClassName}>
      {label && (
        <label className={cn(getLabelClasses({ disabled }), labelClassName)}>{label}</label>
      )}
      <HeadlessSwitch
        checked={checked}
        onChange={onChange}
        as={Fragment}
        disabled={disabled}
        data-qa={dataQa}
        {...rest}>
        {({ checked }) => (
          <button
            className={cn(buttonClasses)}
            // the style above is just for custom colors
            style={{
              backgroundColor: checked && onColor && offColor ? onColor : offColor
            }}>
            <span
              className={cn(knobClasses)}
              style={{
                width: dotSize,
                minWidth: dotSize,
                height: dotSize,
                backgroundColor:
                  checked && onHandleColor && offHandleColor ? onHandleColor : offHandleColor,
                transform: `translateX(${checked ? translateChecked : 0}px)`
              }}
            />
          </button>
        )}
      </HeadlessSwitch>
    </div>
  );
};

export default Switch;
